import React, { useEffect } from "react";
import { useSelector } from "react-redux";
// import Modal from "react-modal";
// import {
//   CallIcon,
//   CheckCircleIcon,
//   ClockIconV3,
//   PersonIcon,
//   XCircleIcon,
//   ExcludeIcon,
//   EyeIcon,
//   CheckIcon,
// } from "../../../images/icons/icons";
// import { formatDateTime } from "../../common-data/Converts";
// import CommonTable from "../../common-components/common-tables/CommonTable";
// import DetailModHeader from "../../common-components/DetailModHeader";
// import TrialAssignForm from "../../pt/three-day-trial/TrialAssignForm";
// import ThreedayTrialHistory from "../../pt/three-day-trial/ThreedayTrialHistory";
// import TrainerMemberMap from "../../trainer-member-engagement/trainer-member-map/TrainerMemberMap";
// import BCAReport from "../../trainer-member-engagement/bca-report/BCAReport";
// import AvailableTrainers from "./AvailableTrainers";
// import ResolutionForm from "../ResolutionForm";
// import ActionButtons from "../ActionButtons";
import LiveTbCols from "../LiveTbCols";
import PTTrialLogCards from "../mobile-view/PTTrialLogCards";

const PTTrialNotificationLogs = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  allDatas,
  setAllDatas,
  userInfoData,
  callFunction,
}) => {
  const {
    ptTrialNotifications,
    ptTrialNotificationsError,
    ptTrialNotificationsLoading,
  } = useSelector((state) => state.live);

  // const iniModValues = {
  //   isModOpen: false,
  //   modName: "",
  //   rowData: "",
  // };
  // const [modValues, setModValues] = useState(iniModValues);

  // const onCloseModal = () => {
  //   setModValues(iniModValues);
  // };

  useEffect(() => {
    if (
      !ptTrialNotificationsLoading &&
      !ptTrialNotificationsError &&
      ptTrialNotifications?.status &&
      ptTrialNotifications?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: ptTrialNotifications.data,
        pagination:
          ptTrialNotifications?.pagination?.length > 0
            ? ptTrialNotifications.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: [],
        pagination: [],
      }));
    }
  }, [
    ptTrialNotificationsLoading,
    ptTrialNotificationsError,
    ptTrialNotifications,
  ]);

  // const tbColumns = [
  //   {
  //     dataField: "user_name",
  //     text: "member info",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex-col">
  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <PersonIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.user_name || "NA"}</span>{" "}
  //           </div>

  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <CallIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.user_mobile || "NA"}</span>{" "}
  //           </div>

  //           {(row?.is_renewal === 1 || row?.is_renewal === 0) && (
  //             <div className="tb-flex">
  //               <span
  //                 className={`tb-badge ${
  //                   row?.is_renewal === 1
  //                     ? "tb-existing"
  //                     : row?.is_renewal === 0
  //                     ? "tb-fresh"
  //                     : ""
  //                 }`}
  //               >
  //                 {row?.is_renewal === 1
  //                   ? "Existing Member"
  //                   : row?.is_renewal === 0
  //                   ? "Fresh"
  //                   : "NA"}
  //               </span>
  //             </div>
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "gym_name",
  //     text: "Gym Name",
  //     formatter: (_, row) => {
  //       return <span className="tb-data">{row?.gym_name || "NA"}</span>;
  //     },
  //   },
  //   {
  //     dataField: "trainer_name",
  //     text: "assigned trainer",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex-col">
  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <PersonIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.trainer_name || "NA"}</span>{" "}
  //           </div>

  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <CallIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.trainer_mobile || "NA"}</span>{" "}
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "date_added",
  //     text: "Member Checkin Time",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex">
  //           <span className="tb-data tb-info-icon">
  //             <ClockIconV3 color="#2c3e50" />
  //           </span>{" "}
  //           <span className="tb-data">
  //             {formatDateTime(row?.date_added || "-")}
  //           </span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "three_day_assigned",
  //     text: "trial",
  //     formatter: (_, row) => {
  //       return (
  //         <span
  //           className="tb-data tb-icon tb-link"
  //           onClick={() =>
  //             setModValues((prevs) => ({
  //               ...prevs,
  //               isModOpen: true,
  //               modName: "trial_history",
  //               rowData: row,
  //             }))
  //           }
  //         >
  //           {row?.three_day_assigned ? <CheckCircleIcon /> : <XCircleIcon />}{" "}
  //           {row?.three_day_done_count}/3
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "bca_status",
  //     text: "BCA",
  //     formatter: (_, row) => {
  //       return (
  //         <span
  //           className="tb-data tb-link"
  //           onClick={() =>
  //             setModValues((prevs) => ({
  //               ...prevs,
  //               isModOpen: true,
  //               modName: "BCA_history",
  //               rowData: row,
  //             }))
  //           }
  //         >
  //           {row?.bca_status?.replace(/_/g, " ") || "view"}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "actions",
  //     text: "Actions",
  //     formatter: (_, row) => {
  //       return (
  //         <>
  //           <ActionButtons
  //             rowData={row}
  //             setModValues={setModValues}
  //             showPTTrial={true}
  //             showMapTrainer={true}
  //             showView={true}
  //             showResolve={true}
  //           />

  //           {/* <div className="pp-employee-payroll-actions">
  //             <button
  //               key="pt-trainer"
  //               type="button"
  //               className="pp-employee-payroll-action-button pp-outlined-border"
  //               onClick={() =>
  //                 setModValues((prevs) => ({
  //                   ...prevs,
  //                   isModOpen: true,
  //                   modName: "trial_assign",
  //                   rowData: row,
  //                 }))
  //               }
  //             >
  //               <ExcludeIcon />
  //               PT trial
  //             </button>

  //             <button
  //               key="map-trainer"
  //               type="button"
  //               className="pp-employee-payroll-action-button pp-outlined-border"
  //               onClick={() =>
  //                 setModValues((prevs) => ({
  //                   ...prevs,
  //                   isModOpen: true,
  //                   modName: "trainer_member_map",
  //                   rowData: row,
  //                 }))
  //               }
  //             >
  //               <ExcludeIcon />
  //               map trainer
  //             </button>

  //             <button
  //               key="available-trainers"
  //               type="button"
  //               className="pp-employee-payroll-action-button pp-outlined-border"
  //               onClick={() =>
  //                 setModValues((prevs) => ({
  //                   ...prevs,
  //                   isModOpen: true,
  //                   modName: "view_details",
  //                   rowData: row,
  //                 }))
  //               }
  //             >
  //               <EyeIcon />
  //               view
  //             </button>

  //             <button
  //               key="resolve"
  //               type="button"
  //               className={`pp-employee-payroll-action-button ${
  //                 row?.is_resolved
  //                   ? "pp-btn-resolved disabled"
  //                   : "pp-outlined-border"
  //               }`}
  //               onClick={() =>
  //                 row?.is_resolved
  //                   ? null
  //                   : setModValues((prevs) => ({
  //                       ...prevs,
  //                       isModOpen: true,
  //                       modName: "resolve",
  //                       rowData: row,
  //                     }))
  //               }
  //               disabled={row?.is_resolved}
  //             >
  //               <CheckIcon />
  //               resolve
  //             </button>
  //           </div> */}
  //         </>
  //       );
  //     },
  //   },
  // ];

  return (
    <>
      <LiveTbCols
        from="pt_trial"
        userInfoData={userInfoData}
        allDatas={allDatas}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        callFunction={callFunction}
        isLoading={ptTrialNotificationsLoading}
      />

      {/* <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Edit Modal"
        ariaHideApp={false}
      >
        {modValues.modName === "resolve" ? (
          <ResolutionForm
            userInfoData={userInfoData}
            rowData={modValues.rowData}
            closeModal={onCloseModal}
            from="pt_trial"
            callFunction={callFunction}
          />
        ) : (
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "trainer_member_map" ||
              modValues.modName === "view_details"
                ? "mod-width-50p"
                : modValues.modName === "trial_assign"
                ? "mod-width-50p mod-height-60vh"
                : "mod-width-95vw mod-height-95vh"
            }`}
          >
            {modValues.modName === "trial_assign" ||
            modValues.modName === "view_details" ? null : (
              <DetailModHeader
                info={modValues.rowData}
                onClose={onCloseModal}
                isOnlySubscription={true}
              />
            )}

            {modValues.modName === "trial_assign" ? (
              <TrialAssignForm
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                userInfoData={userInfoData}
                callFunction={callFunction}
              />
            ) : modValues.modName === "trial_history" ? (
              <ThreedayTrialHistory
                rowData={modValues.rowData}
                userInfoData={userInfoData}
              />
            ) : modValues.modName === "trainer_member_map" ? (
              <TrainerMemberMap
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                callFunction={callFunction}
              />
            ) : modValues.modName === "BCA_history" ? (
              <BCAReport
                userInfoData={userInfoData}
                rowData={modValues.rowData}
              />
            ) : modValues.modName === "view_details" ? (
              <AvailableTrainers
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
              />
            ) : null}
          </div>
        )}
      </Modal>

      <div className="common-table-container mt15">
        <CommonTable
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          tableColumns={tbColumns}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={ptTrialNotificationsLoading}
        />
      </div> */}

      <div className="only-mobile">
        <PTTrialLogCards
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={setIsPage}
        />
      </div>
    </>
  );
};

export default PTTrialNotificationLogs;
